'use es6';

// Deprecated report ids identified and documented in
// https://docs.google.com/spreadsheets/d/1eaFuA22KgI4RSeqo6o0Vqkx9RXST8vFLofaOs0hCrdY/edit?gid=297493949#gid=297493949
export const isCampaignsContactAttributionReport = report => {
  const config = report.get('config');
  return config && config.get('dataType') === 'ANALYTICS_CAMPAIGNS' && config.get('metrics').some(metric => metric.get('property') === 'influencedDeals');
};